module.exports = __webpack_public_path__ + "images/ds-oth-bg-hero-mobile.webp";